import { style } from '@vanilla-extract/css';

export const collapsedQuote = style({
  position: 'relative',
  selectors: {
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 10,
      right: 12,
      width: 6,
      height: 6,
      borderRight: '1px solid currentColor',
      borderBottom: '1px solid currentColor',
      transform: 'rotate(45deg)',
      transformOrigin: 'center',
      opacity: 0.7,
      pointerEvents: 'none',
    },
  },
});
